import { useState, useEffect } from "react";
import LogoImage from "../../../assets/images/logo.png";
import { Button, Input } from "droplr-react-ui-v2";
import "./team-intro-step.scss";
import { ONBOARDING_STEP } from "../../../constants/app.constants";

export interface TeamIntroProps {
  SetCurrentStep: Function;
  OnComplete: Function;
}
export const TeamIntroComponent = ({
  SetCurrentStep,
  OnComplete,
}: TeamIntroProps): JSX.Element => {

  const COMPANY_SIZES = {
    SMALL: {
      label: "1-10",
      value: 1,
    },
    MEDIUM: {
      label: "11-50",
      value: 2,
    },
    LARGE: {
      label: "51-100",
      value: 3,
    },
    HUGE: {
      label: "101-500",
      value: 4,
    },
    ENTERPRISE: {
      label: "500+",
      value: 5,
    },
  };
  const [CompanyName, SetCompanyName] = useState("");
  const [CompanySize, SetCompanySize] = useState(COMPANY_SIZES.SMALL.label);
  const [FormTouched, SetFormTouched] = useState(false);

  return (
    <>
      <div className="team-intro-step step-component-container">
        <div className="logo-image">
          <img src={LogoImage} alt="Droplr Logo" />
        </div>
        <div className="team-intro-step-title">
          Tell us more about your team
        </div>
        <div className="team-intro-step-input">
          <Input
            value={CompanyName}
            onChange={(e: any) => SetCompanyName(e.target.value)}
            label={"Company Name"}
            type="text"
            className="company-name-input"
            placeholder={"Company Name"}
            error={CompanyName === "" && FormTouched ? "This field is required" : ""}
            onKeyPress={() => {
              SetFormTouched(true);
            }}
          />
        </div>
        <div className="size-title">How big is your team?</div>
        <div className="team-intro-company-size">
          <Button
            label={COMPANY_SIZES.SMALL.label}
            variant={
              CompanySize === COMPANY_SIZES.SMALL.label ? "primary" : "secondary"
            }
            
            onClick={() => SetCompanySize(COMPANY_SIZES.SMALL.label)}
          />
          <Button
            label={COMPANY_SIZES.MEDIUM.label}
            variant={
              CompanySize === COMPANY_SIZES.MEDIUM.label ? "primary" : "secondary"
            }
            
            onClick={() => SetCompanySize(COMPANY_SIZES.MEDIUM.label)}
          />
          <Button
            label={COMPANY_SIZES.LARGE.label}
            variant={
              CompanySize === COMPANY_SIZES.LARGE.label ? "primary" : "secondary"
            }
            
            
            onClick={() => SetCompanySize(COMPANY_SIZES.LARGE.label)}
          />
          <Button
            label={COMPANY_SIZES.HUGE.label}
            variant={
              CompanySize === COMPANY_SIZES.HUGE.label ? "primary" : "secondary"
            }
            
            
            onClick={() => SetCompanySize(COMPANY_SIZES.HUGE.label)}
          />
          <Button
            label={COMPANY_SIZES.ENTERPRISE.label}
            variant={
              CompanySize === COMPANY_SIZES.ENTERPRISE.label
                ? "primary"
                : "secondary"
            }
            
            
            onClick={() => SetCompanySize(COMPANY_SIZES.ENTERPRISE.label)}
          />
        </div>
        <div className="team-intro-step-buttons">
          <Button
            label="Back"
            onClick={() => {
                SetCurrentStep(ONBOARDING_STEP.WHO_IS_USING);
            }}
            variant="secondary"
            
            
          />
          <Button
            label="Continue"
            
            disabled={CompanyName === ""}
            onClick={() => {
                OnComplete(CompanyName, CompanySize);
                SetCurrentStep(ONBOARDING_STEP.USAGE);
            }}
            variant="primary"
            
          />
        </div>
      </div>
    </>
  );
};
